/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

import { MmbErrorActionParams } from '../addons/addons.meta';
import {
  AnalyticsBuilderResult,
  EVENTS,
} from '../flightSearch/flightSearch.meta';
import {
  API_ERROR_EVENTS,
  ApiErrorParams,
  ERROR_TRACKING_EVENTS,
  ErrorTrackingParams,
} from './ApiErrors.meta';
import {
  SCREEN_NAME as SCREEN_NAME_V2,
  EVENT_NAMES as EVENT_NAMES_V2,
} from '../../config/analytics';
import { getLineOfBusiness } from '../guest/guest.analytics';

const SCREEN_NAME = 'api_error_v2';
export const CATEGORY = 'api_error';

export const buildApiErrorAnalytics = (
  params: ApiErrorParams,
): AnalyticsBuilderResult => {
  const nativeParams = {
    event: API_ERROR_EVENTS.API_ERROR,
    label: `${SCREEN_NAME}|${params.label}`,
    screen_Name: SCREEN_NAME,
    category: CATEGORY,
    error_message: params.errorMessage,
  };

  const webParams = {
    event: API_ERROR_EVENTS.API_ERROR,
    eventLabel: `${SCREEN_NAME}|${params.label}`,
    eventCategory: CATEGORY,
    errorMessage: params.errorMessage,
  };

  return {
    nativeParams,
    webParams,
  };
};

const ERROR_TRACKING_LINE_OF_BUSINESS = 'Flight';
const ERROR_TRACKING_EVENT_ACTION = 'errors';

export const buildErrorTrackingAnalytics = (
  params: ErrorTrackingParams,
): AnalyticsBuilderResult => {
  const { screenName } = params;
  const category = `error|${params.errorType}`;
  const label = [params.errorCode, params.errorDescription, params.errorMessage]
    .filter((part) => part !== undefined && part !== null && part !== '')
    .join(params.labelSeparator ?? ' | ');

  const nativeParams = {
    category,
    label,
    screenName,
    service: params.service,
    lineofbusiness: ERROR_TRACKING_LINE_OF_BUSINESS,
  };

  const webParams = {
    event: EVENTS.trackEventNoEcommerce,
    eventCategory: category,
    eventLabel: label,
    eventAction: ERROR_TRACKING_EVENT_ACTION,
    screenName,
    service: params.service,
    lineofbusiness: ERROR_TRACKING_LINE_OF_BUSINESS,
  };

  return {
    nativeParams,
    webParams,
  };
};

export const buildMmbErrorAnalytics = (
  params: MmbErrorActionParams,
): AnalyticsBuilderResult => {
  const lineofbusiness = getLineOfBusiness(params?.airlineProfile);
  const nativeParams = {
    category: `api_error|${params?.messageKey}`,
    label: `${params?.code}|${params?.message}`,
    screenName: SCREEN_NAME_V2.mmbAddons,
    lineofbusiness,
  };

  const webParams = {
    event: EVENTS.trackEventNoEcommerce,
    eventCategory: `${params?.category}|${params?.messageKey}`,
    eventAction: EVENT_NAMES_V2.aa_flt_mmb_error,
    eventLabel: `${params?.code}|${params?.message}`,
    screenName: SCREEN_NAME_V2.mmbAddons,
    lineofbusiness,
  };

  return {
    nativeParams,
    webParams,
  };
};
